<template>
  <div class="inventory_content">
   <div class="flex align-center">
    <span>分类：</span>
    <a-radio-group v-model="active" class="radio_contents" size="small" @change="handleChange">
      <a-radio-button v-for="item in option" :key="item.value" :value="item.value" border>{{item.label}}</a-radio-button>
    </a-radio-group>
    <a-alert :message="alertText" type="warning" show-icon />
   </div>
    <!-- <component :is="active" :is-now-wa-customer="isNowWaCustomer" @total="handleTotal"></component> -->
    <advent :is="active" v-if="active==='advent'" :ref="`${active}Ref`" :is-now-wa-customer="isNowWaCustomer" @total="handleTotal"></advent>
    <extended :is="active"  v-else :ref="`${active}Ref`" :is-now-wa-customer="isNowWaCustomer" @total="handleTotal"></extended>
  </div>
</template>

<script>
import activeIcon from '@/assets/img/icon_select.png'
import {postTrack} from '@/utils/point'
import {formatData} from '@/utils/util'
import extended from './components/extended.vue'
import advent from './components/advent.vue'

const activeOption={
  advent:'临期库存',
  extended:'超期库存'
}
  export default {
    name:"ExpireWarning",
    components:{
      extended,
      advent
    },
    props:{
      isNowWaCustomer:{
        type:Boolean,
        default:()=>false
      }
    },
    data(){
      return {
        activeIcon,
        active:'advent',
        messageData:{
          total:0,
          defaultTotal:0,
          bigTotal:0,
        },
      }
    },
    computed:{
      option(){
        return formatData(activeOption)
      },
      alertText(){
        const {total, defaultTotal, bigTotal}=this.messageData;
        if(this.active==='advent'){
          return `共${total}批次临期，临期库存总量${defaultTotal}，临期整单位总量${bigTotal}`;
        }
        return `共${total}批次超期，超期库存总量${defaultTotal}，超期整单位总量${bigTotal}`;
      },
    },
    created(){
      this.handleChange();
    },
    methods:{
      handleChange(){
        postTrack(`数据分析-库存管理-临超期预警-${activeOption[this.active]}`)
        this.$nextTick(()=>{
          this.$refs[`${this.active}Ref`].init()
        })
      },
      handleTotal(data){
        this.$set(this,'messageData',data)
      }
    }
  }
</script>

<style lang="less" scoped>
.inventory_content{
  background-color: #fff;
  padding: 24px 0 0 24px;
}
.radio_contents{
  margin-right: 24px;
  .ant-radio-button-wrapper{
    margin-right: 8px;
    border-radius: 4px;
  }
}
</style>
